"use client";

import { useQuery } from "@apollo/client/react";
import { useEffect } from "react";

import { graphql } from "../../__generated__/gql";

import { useGtm } from "./gtm";

const Query = graphql(`
  query GtmUserId {
    maybeViewer {
      id
    }
  }
`);

export default function GtmUserIdTracker() {
  const { data, loading } = useQuery(Query);
  const gtm = useGtm();
  const rawUserId = data?.maybeViewer?.id ?? null;

  useEffect(() => {
    if (loading) return;
    gtm.setUserId(rawUserId);
  }, [rawUserId, gtm, loading]);

  return null;
}
